import { Component, OnInit } from '@angular/core';
import { CommonService } from './../shared/service/common.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AdminToursService } from '../shared/service/admin-tours.service';
import { Router } from '@angular/router';
import { AdminDestinationService } from '../shared/service/admin-destination.service';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
declare var $: any;
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
const SEARCH_TOUR_TYPE = 'searchTourType';
import { MatDialog } from '@angular/material';
import { InquiryComponent } from '../inquiry/inquiry.component';
import { environment } from './../../environments/environment';
import { AdminLatestTemplateService } from '../shared/service/admin-latest-template.service';
import { AdminHomeSliderService } from '../shared/service/admin-home-slider.service';
import { WriteReviewService } from '../shared/service/write-review.service';
import { StarRatingComponent } from 'ng-starrating';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  LocalToken: string = '';
  defaultImagePath: boolean = true;

  toursArr = [];
  destinationArr = [];

  public coupleTour: any = {};
  public groupTour: any = {};
  public customizedHolidays: any = {};

  //latestTemplateArr: any = [];
  isAdmin: boolean = false;
  homeSliderArr = [];
  imageBaseUrl: string = environment.imageBaseUrl;
  serviceBaseUrl: string = environment.serviceBaseUrl;
  imagePath: string;
  reviewArr: any = [];

  constructor(private adminDestinatinoService: AdminDestinationService, private adminToursService: AdminToursService, private router: Router, private dialog: MatDialog, private autoLogoutService: AutoLogoutService, private adminLatestTemplateService: AdminLatestTemplateService, private adminHomeSliderService: AdminHomeSliderService, private writeReviewService: WriteReviewService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    localStorage.setItem(SEARCH_TOUR_TYPE, "false");
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
    this.writeReviewService.getAllReview()
      .then((res) => {
        this.reviewArr = res;
        console.log(this.reviewArr);
      })
      .catch((err) => console.log(err));
  }

  ngOnInit() {
    setTimeout(() => {
      this.bindSlider();
    }, 1500);

    this.imagePath = "Resources/Images/tours-img/KesaviDefault.jpg";
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    this.getLatestTemplate();
    if (this.LocalToken == null) {
      this.getTours();
      this.getDestination();
      this.getHomeSlider();
      this.isAdmin = false
    }
    else {
      this.isAdmin = true;
    }
  }

  getTours() {
    this.adminToursService
      .getTours()
      .then((result) => {
        this.toursArr = result.slice(0, 6);
      }
      )
      .catch((err) => console.log(err));
  }

  getHomeSlider() {
    this.blockUI.start('Please wait...');
    this.adminHomeSliderService
      .getHomeSlider()
      .then((result) => {
        this.homeSliderArr = result;
        if (this.homeSliderArr.length > 0) {
          for (let i = 0; i < this.homeSliderArr.length; i++) {
            if (this.homeSliderArr[i].TourType == "Group Tours") {
              this.groupTour = this.homeSliderArr[i];
            }
            else if (this.homeSliderArr[i].TourType == "Couple Tours") {
              this.coupleTour = this.homeSliderArr[i];
            }
            else if (this.homeSliderArr[i].TourType == "Customized Holidays") {
              this.customizedHolidays = this.homeSliderArr[i];
            }
            if (!this.homeSliderArr[i].SliderImage) {
              this.homeSliderArr[i].SliderImage = this.imagePath;
            }
          }
        }
        this.blockUI.stop();
      })
      .catch((err) => console.log(err));
  }

  bindSlider() {
    var welcomeSlide = $('.hero-slides');

    welcomeSlide.owlCarousel({
      items: 1,
      margin: 0,
      loop: true,
      nav: true,
      navText: ['Prev', 'Next'],
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      smartSpeed: 1000
    });

    welcomeSlide.on('translate.owl.carousel', function () {
      var slideLayer = $("[data-animation]");
      slideLayer.each(function () {
        var anim_name = $(this).data('animation');
        $(this).removeClass('animated ' + anim_name).css('opacity', '0');
      });
    });

    welcomeSlide.on('translated.owl.carousel', function () {
      var slideLayer = welcomeSlide.find('.owl-item.active').find("[data-animation]");
      slideLayer.each(function () {
        var anim_name = $(this).data('animation');
        $(this).addClass('animated ' + anim_name).css('opacity', '1');
      });
    });

    $("[data-delay]").each(function () {
      var anim_del = $(this).data('delay');
      $(this).css('animation-delay', anim_del);
    });

    $("[data-duration]").each(function () {
      var anim_dur = $(this).data('duration');
      $(this).css('animation-duration', anim_dur);
    });

    var dot = $('.hero-slides .owl-dot');
    dot.each(function () {
      var index: any = $(this).index() + 1 + '.';
      if (index < 10) {
        $(this).html('0').append(index);
      } else {
        $(this).html(index);
      }
    });

    setTimeout(() => {
      $('.owl-dots').hide();
    }, 1500);

  }

  getDestination() {
    this.adminDestinatinoService
      .getDestination()
      .then((result) => {
        this.destinationArr = result.slice(0, 5);
        for (let j = 0; j < this.destinationArr.length; j++) {
          if (this.destinationArr[j].ImageUrl) {
            this.destinationArr[j].ImageUrl = 'Resources/Images/Destinations/' + this.destinationArr[j].Id + '/' + this.destinationArr[j].ImageUrl;
          }
          else {
            this.destinationArr[j].ImageUrl = this.imagePath;
          }
        }
      })
      .catch((err) => console.log(err));
  }

  // getLatestTemplate() {

  //   this.adminLatestTemplateService
  //     .getLatestTemplate()
  //     .then((result) => {
  //       if (result.length > 0) {
  //         this.latestTemplateArr = result[0];
  //         if (this.adminLatestTemplateService.isModel) {
  //           setTimeout(() => {
  //             $('#imageModel').modal('show');
  //             this.adminLatestTemplateService.isModel = false;
  //           }, 500);
  //         }
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // }

  getLatestTemplate() {

    this.adminLatestTemplateService
      .getLatestTemplate()
      .then((result) => {
        if (result.length > 0) {
          if (this.adminLatestTemplateService.isModel) {
            setTimeout(() => {
              // $('#imageModel').modal('show');
              this.adminLatestTemplateService.isModel = false;
            }, 500);
          }
        }
      })
      .catch((err) => console.log(err));
  }

  seeMoreTours() {
    this.router.navigate(["allTours"]);
  }

  toursDetails(toursType) {
    localStorage.setItem(SEARCH_TOUR_TYPE, "true");
    if (toursType == "India Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "World Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Special Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Group Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Couple Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Corporate Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Economy Tours") {
      this.router.navigate(["allTours/" + toursType]);
    }
    if (toursType == "Customized Holidays") {
      this.router.navigate(["allTours/" + toursType]);
    }
  }

  openInquiryDialog() {
    const dialogRef = this.dialog.open(InquiryComponent, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

